export const timings = {
  featured: 1500,
  works: 1500,
  talent: 1500,
};
